import { Box, Button, CircularProgress, InputLabel, MenuItem, Select, Stack, TextField, Typography } from "@mui/material";
import { GlobalState } from "context/GlobalContext";
import CodeIcon from "@mui/icons-material/Code";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";
import FileSaver from "file-saver";

const InventorySnapshot = () => {
	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();
	const [loading, setLoading] = useState(false);
	const [sync, setSync] = useState();

	const fetchSync = async () => {
		try {
			await axios.get(`/api/custom_queries/fetch_last_sync`).then((res) => {
				if (res.status === 200) {
					setSync(res?.data[0]?.api_pull_last_updated);
					setLoading(false);
				}
			});
		} catch (error) {
			setLoading(false);
		}
	};
	useEffect(() => {
		fetchSync();
	}, []);

	const handleRunQueryClick = async (e) => {
		e.preventDefault();
		setLoadingOpen(true);
		await pythonVmInstance({
			url: `/wh-soh/download`,
			headers: {
				"Content-Type": "application/json",
			},
			method: "GET",
			responseType: "blob",
		})
			.then((res) => {
				const url = URL.createObjectURL(res.data);
				FileSaver.saveAs(url, `inventory_snapshot_${new Date().toISOString().split("T")[0]}.csv`);
				setLoadingOpen(false);
				setSnackBarOpen(true);
				setSnackBar({
					...snackBar,
					message: "Downloaded the file",
					severity: "success",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			})
			.catch((err) => {
				console.log(err);
				setSnackBarOpen(true);
				setLoadingOpen(false);
				setSnackBar({
					...snackBar,
					message: "Unable to Download the file",
					severity: "error",
					anchorOrigin: { horizontal: "center", vertical: "top" },
				});
			});
	};

	return (
		<Stack spacing={2} component="form" onSubmit={handleRunQueryClick}>
			{/* <Typography variant="h6">Inventory Snapshot Download</Typography> */}
			<Typography variant="subtitle1" pt={2}>
				Last synced with UC: {sync}
				{/* ⚠️ Temporary Unavailability <br />
				UC is currently updating their internal structure. The report download feature is temporarily unavailable. We
				appreciate your patience! */}
			</Typography>

			<Button
				variant="contained"
				disabled={loading}
				sx={{ width: "200px" }}
				type="submit"
				startIcon={loading ? <CircularProgress color="inherit" size="20px" /> : ""}>
				{loading ? "Loading..." : "Download"}
			</Button>
		</Stack>
	);
};

export default InventorySnapshot;
